
/**
 * Publikus lapokon publikus vagy szerkesztés alatti tartalmat jelenítsünk-e meg
 * addig amíg nincsenek publikálva a könyvek.
 */
export function showUnpublished() {
    return false;
}
